import Document from './src/document-combined';
export default Document;